import { SIDEBAR_DARK } from "@funded-here-interface/common/src/constant/color";
import { createStyles } from "@mantine/styles";

export const useStyles = createStyles(() => ({
  sideBarContainer: {
    position: "fixed",
    height: "100vh",
    backgroundColor: SIDEBAR_DARK,
    width: 240,
    display: "flex",
    flexDirection: "column",
  },
  embedded: {
    position: "static",
    width: "100%",
    height: "100%",
  },
  iconbox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: "100%",
  },
  link: {
    textDecoration: "none",
    color: "white",
    display: "flex",
    alignItems: "center",

    "& .mantine-NavLink-label, & .mantine-NavLink-icon, & .mantine-NavLink-rightSection": {
      color: "#FFFFFF",
    },

    "&:hover:hover": {
      backgroundColor: "#223e41",
      color: "#FFFFFF",
      borderRadius: "10px",
      "& .mantine-NavLink-label, & .mantine-NavLink-icon, & .mantine-NavLink-rightSection": {
        color: "#FFFFFF",
      },
    },

    "&[data-active][data-active]": {
      borderRadius: "10px",
      color: "#FFFFFF",
      backgroundColor: "#223e41",
      "& .mantine-NavLink-label, & .mantine-NavLink-icon, & .mantine-NavLink-rightSection": {
        color: "#FFFFFF",
      },
    },
  },
  scrollArea: {
    flex: 1,
    margin: "0 20px",
  },
  personItem: {
    display: "flex",
    alignItems: "center",
    padding: "8px 10px",
    color: "white",
  },
  footer: {
    margin: "40px 20px",
    borderTop: "1px solid #FFFFFF",
    color: "white",
    paddingBottom: 60,
  },
}));
